import './CRMUnsubscribe.scss'

import { FormInput } from '@bob/library'
import { Button } from '@websrc/App/Components/Button/Button'
import { useStaticText } from '@websrc/App/Hooks/useStaticText'
import { useUnsubscribe } from '@websrc/Spot/CRMUnsubscribe/useUnsubscribe'
import React, { FC, useEffect, useState } from 'react'

interface CRMUnsubscribeProps {
  unsubscribe: {
    header: string
    success_header: string
    success_message: string
  }
}

export const CRMUnsubscribe: FC<any> = (props: CRMUnsubscribeProps) => {
  const { header, success_header, success_message } = props.unsubscribe
  const t = useStaticText()
  const [error, setError] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [isUnsubscribed, setIsUnsubscribed] = useState(false)
  const [crmEmail, setCrmEmail] = useState('')
  const [crmToken, setCrmToken] = useState('')
  const { getEmail, unsubscribeEmail } = useUnsubscribe()

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search)
    const token = urlParams.get('token') as string
    setCrmToken(token)

    setIsLoading(true)
    getEmail(token)
      .then((email) => {
        setCrmEmail(email)
        setIsLoading(false)
      })
      .catch(() => {
        setError(t.unsubscribe.email_not_found)
        setIsLoading(false)
      })
  }, [getEmail, t.unsubscribe.email_not_found])

  const unsubscribe = () => {
    setIsLoading(true)
    unsubscribeEmail(crmEmail, crmToken)
      .then(() => {
        setIsLoading(false)
        setIsUnsubscribed(true)
      })
      .catch(() => {
        setError(t.unsubscribe.technical_error)
        setIsLoading(false)
      })
  }

  return (
    <div className={'crm-unsubscribe'}>
      <div className={'crm-unsubscribe__title'}>{!isUnsubscribed ? header : success_header}</div>
      {!isUnsubscribed ? (
        <div>
          <div className={'crm-unsubscribe__wrapper'}>
            <FormInput
              className={'crm-unsubscribe__input'}
              disabled={true}
              type={'text'}
              value={crmEmail}
            />
            <Button
              color={'black'}
              colorMode={'light'}
              disabled={isLoading || crmEmail == ''}
              isLoading={isLoading}
              onClick={() => unsubscribe()}
              size={'medium'}
              text={isLoading ? '' : t.unsubscribe.button_label}
              type={'primary'}
            />
          </div>
          {error && <div className={'crm-unsubscribe__error'}>{error}</div>}
        </div>
      ) : (
        <div>{success_message}</div>
      )}
    </div>
  )
}
